import LimitedTextWithTooltip from 'components/base/LimitedTextWithTooltip';
import { StyledCell } from '../../../../../../ResourceAllocationOverview/JiraStats/useTableRows/Row.style';

const TextCell = ({ text }) => {
  return (
    <StyledCell>
      <LimitedTextWithTooltip text={text} max={50} />
    </StyledCell>
  );
};

export default TextCell;
